/**
 * 时间/日期常数
 */

/**
 * 最大的年份
 * @type {number}
 */
export const MAX_YEAR = 9999

/**
 * 最大的月份
 * @type {number}
 */
export const MAX_MONTH = 11

/**
 * 最大的日期
 * @type {number}
 */
export const MAX_DAY = 31

/**
 * 最大的小时
 * @type {number}
 */
export const MAX_HOUR = 23

/**
 * 最大的分钟
 * @type {number}
 */
export const MAX_MINUTE = 59

/**
 * 最大的秒
 * @type {number}
 */
export const MAX_SECOND = 59

/**
 * 最大的毫秒
 * @type {number}
 */
export const MAX_MILLISECOND = 999

/**
 * 最大的日期时间
 * @type {Date}
 */
export const MAX_DATE = new Date(MAX_YEAR, MAX_MONTH, MAX_DAY, MAX_HOUR, MAX_MINUTE, MAX_SECOND, MAX_MILLISECOND)

/**
 * 默认的日期格式
 * @type {string}
 */
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'

/**
 * 默认的时间格式
 * @type {string}
 */
export const DEFAULT_TIME_FORMAT = 'HH:mm'

/**
 * 默认的日期时间格式
 * @type {string}
 */
export const DEFAULT_DATETIME_FORMAT = 'yyyy-MM-dd HH:mm'
